import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../services/authContext';

const Unauthorized = () => {
  const { user } = useAuth();
  
  return (
    <div className="unauthorized-page">
      <div className="unauthorized-container">
        <div className="unauthorized-icon">🔒</div>
        <h1>Access Denied</h1>
        <p>You don't have permission to access this page.</p>
        <p>Your current role: <strong>{user ? user.role : 'Not logged in'}</strong></p>
        <div className="unauthorized-actions">
          <Link to="/dashboard" className="btn btn-primary">
            Go to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;